import { useCallback } from 'react';
import { create } from 'zustand';
import axios from 'axios';

// ======================
// Types
// ======================

interface NotificationSettingsStore {
  defaultNotificationWindow: number | undefined;
  setDefaultNotificationWindow: (value: number | undefined) => void;
}

type TNotificationSettingsResponse = {
  notificationSettings: {
    defaultNotificationWindow: number;
  };
};

// ======================
// Store
// ======================

export const useNotificationSettingsStore = create<NotificationSettingsStore>((set) => ({
  defaultNotificationWindow: undefined,
  setDefaultNotificationWindow: (defaultNotificationWindow) => set({ defaultNotificationWindow })
}));

// ======================
// Helpers
// ======================

const mapNotificationSettingsResponse = (
  data: TNotificationSettingsResponse
): number | undefined => {
  const value = data?.notificationSettings?.defaultNotificationWindow;
  return typeof value === 'number' ? value : undefined;
};

// ======================
// Hooks
// ======================

export const useFetchNotificationSettings = () => {
  const { setDefaultNotificationWindow } = useNotificationSettingsStore();

  const init = useCallback(async () => {
    try {
      const { data } = await axios.get<TNotificationSettingsResponse>('/notification-settings');
      setDefaultNotificationWindow(mapNotificationSettingsResponse(data));
    } catch (error) {
      console.error('Failed to fetch notification settings:', error);
    }
  }, [setDefaultNotificationWindow]);

  return init;
};
